import { ProfileUpdateRequest, ProfileUpdateResponse } from "../model";
import { apiClient } from "../../../shared/api/client";

/**
 * 프로필 API: 순수 HTTP 통신만 담당
 * 백엔드와의 통신을 담당합니다
 */
class ProfileAPI {
  /**
   * 사용자 프로필 조회 API 호출
   * @returns 사용자 프로필 정보
   */
  async getProfile(): Promise<ProfileUpdateResponse> {
    try {
      const response = await apiClient.get<ProfileUpdateResponse>(
        `/v1/users/me`
      );
      return response.data;
    } catch (err) {
      throw this.handleError(err);
    }
  }

  /**
   * 프로필 업데이트 API 호출
   * @param userId 사용자 ID
   * @param data 업데이트할 프로필 정보
   * @returns 업데이트된 사용자 정보
   */
  async updateProfile(
    userId: string,
    data: ProfileUpdateRequest
  ): Promise<ProfileUpdateResponse> {
    try {
      const response = await apiClient.put<ProfileUpdateResponse>(
        `/v1/users/${userId}`,
        data
      );
      return response.data;
    } catch (err) {
      throw this.handleError(err);
    }
  }

  /**
   * 회원 탈퇴 API 호출
   * @param password 사용자 비밀번호
   * @returns 탈퇴 결과
   */
  async deactivateAccount(password: string): Promise<any> {
    try {
      const response = await apiClient.post<any>(`/v1/users/deactivate`, {
        password,
      });
      return response.data;
    } catch (err) {
      throw this.handleError(err);
    }
  }

  /**
   * 에러 처리
   */
  private handleError(err: any): Error {
    if (err.response?.data?.message) {
      return new Error(err.response.data.message);
    }
    if (err.message) {
      return new Error(err.message);
    }
    return new Error("API 호출 실패");
  }
}

export const profileAPI = new ProfileAPI();
